import { AnyAction } from "redux";
import {
  CLEAR_ACTIVE_KPI_ID,
  SET_ACTIVE_KPI_ID
} from "../actions/activeKpi";

export const activeKpi = (state = 0, action: AnyAction) => {
  switch (action.type) {
    case SET_ACTIVE_KPI_ID:
      return action.id as number;
    case CLEAR_ACTIVE_KPI_ID:
      return 0;
    default:
      return state;
  }
};

export default activeKpi;
